module.exports = __webpack_public_path__ + "img/chambre 3.45d5067b.jpeg";